import React, { useContext } from 'react';
import { ISocialIframeProps } from './social-embed';
import { AmpPropsContext } from '../../context/amp-props/amp-props-provider';
import { IAmpPropsTag } from '../../typings/amp';
import { getAmpTag } from '../../utils/amp';
import { getYoutubeVideoiId } from '../../utils/socials';
import AmpYoutube from '../amp/amp-youtube';

const YoutubeIframe: React.FC<ISocialIframeProps> = ({ src }) => {
  const { ampProps } = useContext(AmpPropsContext);

  const ampYoutube: IAmpPropsTag | undefined = getAmpTag(ampProps, 'youtube');
  const videoId = getYoutubeVideoiId(src);

  return ampYoutube ? (
    <AmpYoutube
      videoId={videoId}
      width={ampYoutube.width}
      height={ampYoutube.height}
      layout={ampYoutube.layout}
      dataBlockOnConsent={ampYoutube.dataBlockOnConsent}
    />
  ) : (
    <iframe
      width="560"
      height="315"
      src={src}
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
};

export default YoutubeIframe;
